export default {"src":"/_next/static/media/heartWithPaw_24.fc1818d8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};